export default {
  "pages.layouts.userLayout.title":
    "Chatbot Portal - Giải pháp hỗ trợ, tư vấn và giao tiếp tự động cho doanh nghiệp và khách hàng",
  "pages.login.accountLogin.tab": "Đăng nhập bằng tài khoản FPT",
  "pages.login.accountLogin.errorMessage":
    "Sai tên đăng nhập/mật khẩu (admin/ant.design)",
  "pages.login.failure": "Đăng nhập thất bại, vui lòng thử lại!",
  "pages.login.success": "Đăng nhập thành công!",
  "pages.login.username.placeholder": "Tên đăng nhập: admin hoặc user",
  "pages.login.username.required": "Vui lòng nhập tên đăng nhập!",
  "pages.login.password.placeholder": "Mật khẩu: ant.design",
  "pages.login.password.required": "Vui lòng nhập mật khẩu!",
  "pages.login.phoneLogin.tab": "Đăng nhập bằng điện thoại",
  "pages.login.phoneLogin.errorMessage": "Mã xác thực không đúng",
  "pages.login.phoneNumber.placeholder": "Số điện thoại",
  "pages.login.phoneNumber.required": "Vui lòng nhập số điện thoại!",
  "pages.login.phoneNumber.invalid": "Số điện thoại không hợp lệ!",
  "pages.login.captcha.placeholder": "Mã xác thực",
  "pages.login.captcha.required": "Vui lòng nhập mã xác thực!",
  "pages.login.phoneLogin.getVerificationCode": "Lấy mã",
  "pages.getCaptchaSecondText": "giây",
  "pages.login.rememberMe": "Ghi nhớ đăng nhập",
  "pages.login.forgotPassword": "Quên mật khẩu?",
  "pages.login.submit": "Đăng nhập",
  "pages.login.loginWith": "Đăng nhập bằng:",
  "pages.login.registerAccount": "Đăng ký tài khoản",
  "pages.welcome.link": "Chào mừng",
  "pages.welcome.alertMessage":
    "Các thành phần mạnh mẽ và nhanh hơn đã được phát hành.",
  "pages.404.subTitle": "Xin lỗi, trang bạn truy cập không tồn tại.",
  "pages.404.buttonText": "Quay về trang chủ",
  "pages.admin.subPage.title": "Trang này chỉ dành cho quản trị viên",
  "pages.admin.subPage.alertMessage":
    "Umi ui đã ra mắt, hãy sử dụng npm run ui để trải nghiệm.",
  "pages.searchTable.createForm.newRule": "Tạo quy tắc mới",
  "pages.searchTable.updateForm.ruleConfig": "Cấu hình quy tắc",
  "pages.searchTable.updateForm.basicConfig": "Thông tin cơ bản",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Tên quy tắc",
  "pages.searchTable.updateForm.ruleName.nameRules":
    "Vui lòng nhập tên quy tắc!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Mô tả quy tắc",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder":
    "Vui lòng nhập ít nhất năm ký tự",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "Vui lòng nhập mô tả quy tắc ít nhất năm ký tự!",
  "pages.searchTable.updateForm.ruleProps.title": "Cấu hình thuộc tính",
  "pages.searchTable.updateForm.object": "Đối tượng giám sát",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Mẫu quy tắc",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Loại quy tắc",
  "pages.searchTable.updateForm.schedulingPeriod.title":
    "Thiết lập chu kỳ lập lịch",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel":
    "Thời gian bắt đầu",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules":
    "Vui lòng chọn thời gian bắt đầu!",
  "pages.searchTable.titleDesc": "Mô tả",
  "pages.searchTable.ruleName": "Tên quy tắc là bắt buộc",
  "pages.searchTable.titleCallNo": "Số lần gọi dịch vụ",
  "pages.searchTable.titleStatus": "Trạng thái",
  "pages.searchTable.nameStatus.default": "mặc định",
  "pages.searchTable.nameStatus.running": "đang chạy",
  "pages.searchTable.nameStatus.online": "trực tuyến",
  "pages.searchTable.nameStatus.abnormal": "bất thường",
  "pages.searchTable.titleUpdatedAt": "Lập lịch lần cuối lúc",
  "pages.searchTable.exception": "Vui lòng nhập lý do ngoại lệ!",
  "pages.searchTable.titleOption": "Tùy chọn",
  "pages.searchTable.config": "Cấu hình",
  "pages.searchTable.subscribeAlert": "Đăng ký nhận cảnh báo",
  "pages.searchTable.title": "Biểu mẫu tra cứu",
  "pages.searchTable.new": "Mới",
  "pages.searchTable.chosen": "đã chọn",
  "pages.searchTable.item": "mục",
  "pages.searchTable.totalServiceCalls": "Tổng số lần gọi dịch vụ",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.batchDeletion": "Xóa hàng loạt",
  "pages.searchTable.batchApproval": "Duyệt hàng loạt",
  "pages.customerData.title": "Dữ liệu khách hàng",
  "pages.customerData.dataName": "Tên dữ liệu",
  "pages.customerData.dataType": "Kênh chat",
  "pages.customerData.createdAt": "Ngày tạo",
  "pages.customerData.createdBy": "Người tạo",
  "pages.customerData.updatedAt": "Ngày cập nhật",
  "pages.customerData.updatedBy": "Người cập nhật",
  "pages.customerData.dataList": "Danh sách dữ liệu",
  "pages.customerData.import.success": "Nhập dữ liệu thành công!",
  "pages.customerData.import.failure": "Nhập dữ liệu thất bại!",
  "pages.customerData.import.error": "Lỗi nhập dữ liệu!",
  "pages.customerData.import.title": "Nhập dữ liệu",
  "pages.customerData.update.title": "Cập nhật dữ liệu",
  "pages.customerData.import": "Nhập dữ liệu",
  "pages.customerData.update": "Cập nhật dữ liệu",
  "pages.customerData.form.details": "Danh sách chi tiết khách hàng",
  "pages.customerData.form.extraField": "Các trường bổ sung",
  "pages.customerData.form.extraField.key": "Từ khóa",
  "pages.customerData.form.extraField.value": "Giá trị",
  "pages.customerData.form.addDetail": "Thêm",
  "pages.customerData.form.addExtraField": "Thêm",
  "pages.customerData.form.deleteDetail": "Xoá",
  "pages.customerData.form.deleteExtraField": "Xoá",
  "pages.customerData.form.requirementField": "User ID",
  "pages.customerData.form.targetType": "Loại đối tượng",
  "pages.configInfoNoti.configName": "Tên dữ liệu",
  "pages.configInfoNoti.configType": "Kênh chat",
  "pages.configInfoNoti.createdAt": "Ngày tạo",
  "pages.configInfoNoti.createdBy": "Người tạo",
  "pages.configInfoNoti.updatedAt": "Ngày cập nhật",
  "pages.configInfoNoti.updatedBy": "Người cập nhật",
  "pages.configInfoNoti.import": "Nhập dữ liệu",
  "pages.configInfoNoti.dataList": "Danh sách dữ liệu",
  "pages.configInfoNoti.import.success": "Nhập dữ liệu thành công!",
  "pages.configInfoNoti.import.failure": "Nhập dữ liệu thất bại!",
  "pages.configInfoNoti.import.error": "Lỗi nhập dữ liệu!",
  "pages.configInfoNoti.import.title": "Nhập dữ liệu",
  "pages.configInfoNoti.update.title": "Cập nhật dữ liệu",
  "pages.configInfoNoti.update": "Cập nhật dữ liệu",
  "pages.configInfoNoti.update.success": "Cập nhật dữ liệu thành công!",
  "pages.configInfoNoti.form.details": "Cấu hình kênh chat",
  "pages.configInfoNoti.form.extraField": "Các trường bổ sung",
  "pages.configInfoNoti.form.extraField.key": "Từ khóa",
  "pages.configInfoNoti.form.extraField.value": "Giá trị",
  "pages.configInfoNoti.form.addDetail": "Thêm",
  "pages.configInfoNoti.form.addExtraField": "Thêm",
  "pages.configInfoNoti.form.deleteDetail": "Xoá",
  "pages.configInfoNoti.form.deleteExtraField": "Xoá",
  "pages.campaignConfig.campaignName": "Tên Chiến Dịch",
  "pages.campaignConfig.campaignType": "Kênh chat",
  "pages.campaignConfig.campaignStatus": "Trạng thái",
  "pages.campaignConfig.createdAt": "Ngày tạo",
  "pages.campaignConfig.createdBy": "Người tạo",
  "pages.campaignConfig.updatedAt": "Ngày cập nhật",
  "pages.campaignConfig.updatedBy": "Người cập nhật",
  "pages.campaignConfig.import": "Tạo chiến dịch",
  "pages.campaignConfig.dataList": "Danh sách dữ liệu",
  "pages.campaignConfig.import.success": "Nhập dữ liệu thành công!",
  "pages.campaignConfig.import.failure": "Nhập dữ liệu thất bại!",
  "pages.campaignConfig.import.error": "Lỗi nhập dữ liệu!",
  "pages.campaignConfig.import.title": "Nhập dữ liệu",
  "pages.campaignConfig.update.title": "Cập nhật dữ liệu",
  "pages.campaignConfig.update": "Cập nhật dữ liệu",
  "pages.campaignConfig.form.details": "Cấu hình kênh chat",
  "pages.campaignConfig.form.extraField": "Các trường bổ sung",
  "pages.campaignConfig.form.extraField.key": "Từ khóa",
  "pages.campaignConfig.form.extraField.value": "Giá trị",
  "pages.campaignConfig.form.addDetail": "Thêm",
  "pages.campaignConfig.form.addExtraField": "Thêm",
  "pages.campaignConfig.form.deleteDetail": "Xoá",
  "pages.campaignConfig.form.deleteExtraField": "Xoá",
  "pages.campaignConfig.form.configNotiId": "Thông báo",
  "pages.campaignConfig.form.customerDataId": "Dữ liệu khách hàng",
  "pages.campaignConfig.form.startTime": "Ngày bắt đầu",
  "pages.campaignConfig.form.endTime": "Ngày kết thúc",
};
